import { Controller } from '@hotwired/stimulus';

export default class ScrollIntoViewController extends Controller {
  static values = {
    targetId: String
  };

  scrollToTarget() {
    const element = document.getElementById(this.targetIdValue);
    if (!element) {
      throw new Error('Target element does not exist');
    }
    element.scrollIntoView({ behavior: 'smooth' });
  }
}
